<template>
  <section class="wrapper-interactions">
    <div
      v-for="(chart, index) in getChartsOrderByChannel"
      :key="index"
    >
      <component :is="chart.component" />
    </div>
  </section>
</template>

<script>
import { InteractionsOverTime } from '@/components/content/InteractionsOverTime';
import { InteractionsAndEngagementRate } from '@/components/content/InteractionsAndEngagementRate';
import { InteractionsBySocialNetworkAndMediaType } from '@/components/content/InteractionsBySocialNetworkAndMediaType';
import { EngagementOverTime } from '@/components/content/EngagementOverTime';
import { AverageInteractionsByPublication } from '@/components/content/AverageInteractionsByPublication';
import { EngagementMatrix } from '@/components/content/EngagementMatrix';
import { DistributionOfInteractions } from '@/components/content/DistributionOfInteractions';

import { isRunningProductionEnvironment } from '@/utils';

export default {
  name: 'SectionInteractions',
  components: {
    InteractionsOverTime,
    InteractionsAndEngagementRate,
    InteractionsBySocialNetworkAndMediaType,
    EngagementOverTime,
    AverageInteractionsByPublication,
    EngagementMatrix,
    DistributionOfInteractions,
  },
  computed: {
    getChartsOrderByChannel() {
      const channel = this.$store.state.ui.channel.toLowerCase();

      const componentOrdersByChannel = {
        InteractionsBySocialNetworkAndMediaType: {
          todas: 1,
          instagram: 4,
          facebook: 4,
          twitter: 4,
          youtube: 4,
        },
        AverageInteractionsByPublication: {
          todas: 2,
          instagram: 2,
          facebook: 2,
          twitter: 2,
          youtube: 2,
        },
        InteractionsOverTime: {
          todas: 3,
          instagram: 3,
          facebook: 3,
          twitter: 3,
          youtube: 3,
        },
        EngagementOverTime: {
          todas: 4,
          instagram: 5,
          facebook: 5,
          twitter: 5,
          youtube: 5,
        },
        InteractionsAndEngagementRate: {
          todas: 5,
          instagram: 6,
          facebook: 6,
          twitter: 6,
          youtube: 6,
        },
        EngagementMatrix: {
          todas: !isRunningProductionEnvironment && 7,
          instagram: undefined,
          facebook: 7,
          twitter: 7,
          youtube: 7,
        },
        DistributionOfInteractions: {
          todas: undefined,
          instagram: 1,
          facebook: 1,
          twitter: 1,
          youtube: 1,
        },
      };

      return Object.keys(componentOrdersByChannel)
        .map(component => {
          const ordersByChannel = componentOrdersByChannel[component];
          const getOrder = channel in ordersByChannel ? ordersByChannel[channel] : ordersByChannel.todas;

          return {
            order: getOrder,
            component,
          };
        })
        .filter(r => r.order)
        .sort((a, b) => a.order - b.order);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-interactions {
  & > div:not(:first-child) {
    margin-top: var(--ds-spacing-stack-md);
  }
}
</style>
